<wbo-edit-page [title]="model.data.contact.fullName" #editPage>
    <fui-formation-group-template *formationGroup="{title: 'wbo.employee.edit.formation.contact', formControlNames: 'contact'}">
        <wbo-contact-edit [formGroupContact]="editPage.formGroup.controls['contact']" [contact]="model.data.contact"></wbo-contact-edit>
    </fui-formation-group-template>
    <fui-formation-group-template *formationGroup="{title: 'wbo.employee.edit.formation.employment',
        formControlNames: ['user.accessRole', 'position', 'status', 'hourlyRate', 'comments', 'startDate']}">
        <wbo-employee-edit-employment></wbo-employee-edit-employment>
    </fui-formation-group-template>
    <fui-formation-group-template *formationGroup="{title: 'wbo.employee.edit.formation.user', formControlNames: 'user'}">
        <wbo-employee-edit-user></wbo-employee-edit-user>
    </fui-formation-group-template>
</wbo-edit-page>
